// The sidebar status-count keys + invalidator — the data half of the
// multiplayer↔scribe knot, moved verbatim from
// `src/components/layout/Navigation/sessions/hooks/sessionStatusCountKeys.ts`
// (which re-exports from here) with the D1 family. The keys are now
// single-sourced from contracts (their parity rows retire); the app's
// `reactQueryClient` module read became the injected `getQueryClient` seam.

import {
  GET_SESSION_STATUS_COUNT,
  GET_SESSION_STATUS_COUNTS,
  GET_TEAM_MEMBER_SESSION_STATUS_COUNT,
} from '../../contracts';
import { getSessionDataConfig } from '../config';

export { GET_SESSION_STATUS_COUNT, GET_TEAM_MEMBER_SESSION_STATUS_COUNT };

export function invalidateSessionStatusCount() {
  const queryClient = getSessionDataConfig().getQueryClient();
  return Promise.all([
    queryClient.invalidateQueries({
      queryKey: [GET_SESSION_STATUS_COUNT],
    }),
    queryClient.invalidateQueries({
      queryKey: [GET_TEAM_MEMBER_SESSION_STATUS_COUNT],
    }),
    queryClient.invalidateQueries({
      queryKey: [GET_SESSION_STATUS_COUNTS],
    }),
  ]);
}
